import { createSlice } from "@reduxjs/toolkit";
// import { disableLoading } from "~/loadingStatus";

const initialState = { status: "" };

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state, action) => {
      // sessionStorage.clear();
      // window.location = action.payload;
      state.status = action.payload;
    },
    resetState: (state, action) => {
      state.status = "";
    },
  },
});

const { reducer, actions } = authSlice;
export const { logout, resetState } = actions;
export default reducer;
